module.exports = __webpack_public_path__ + "static/media/masculino.700f5a46.png";